import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  Input,
  SelectPicker,
  ControlLabel,
  RadioGroup,
  Radio,
  Message,
  IconButton,
  Icon,
  ButtonGroup,
  ButtonToolbar,
  Whisper,
  Tooltip,
  List,
  FlexboxGrid,
} from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import InputForm from '../../../components/forms/input/InputForm'
import { getMaxLengthData, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import CKEditorBlankFrom from '../../../components/forms/input/CKEditorBlankFrom'
import { v4 as uuidv4 } from 'uuid'
import { cloneDeep } from 'lodash-es'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import { REQUEST_DATE_FORMAT } from '../../../constants/date'
import moment from 'moment'
import './styles.less'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'

export default function ReportsAuditForm({
  schema: _schema,
  auditRole,
  loading,
  register,
  Controller,
  control,
  errors,
  getValues,
  setValue,
  clearErrors,
  onSubmitDraftOne = () => {},
  onSearch = () => {},
  disabled,
  ...props
}) {
  const [checkRadio, setCheckRadio] = useState(null)
  const [formSchema, setFormSchema] = useState(_schema)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [request, setRequest] = useState()
  const [auditDate, setAuditDate] = useState(
    formSchema?.auditDate?.value
      ? moment(formSchema?.auditDate?.value, REQUEST_DATE_FORMAT).toDate()
      : moment().startOf('day').toDate()
  )
  const [isError, setIsError] = useState(false)

  const [auditBudgetValues, setAuditBudgetValues] = useState(_)
  const [auditPeriodValues, setAuditPeriodValues] = useState()

  const headerStyle = {
    textAlign: 'center',
    border: '1px solid #d3caca',
    backgroundColor: '#e4e5e7',
    fontWeight: 'bold',
    padding: 5,
    marginTop: 5,
  }

  useEffect(() => {
    register(formSchema.auditDate.name)
    register(formSchema.projectGrade.name)
    setValue(
      formSchema.projectGrade.name,
      formSchema.projectGrade.value == 0 ? null : formSchema.projectGrade.value
    )
    // const defAuditDate = formSchema?.auditDate?.value
    //   ? moment(formSchema?.auditDate?.value, REQUEST_DATE_FORMAT).toDate()
    //   : moment().startOf('day').toDate()

    const defAuditDate = formSchema?.auditDate?.value
      ? formSchema.auditDate.value
      : moment().format(REQUEST_DATE_FORMAT)

    // moment(formSchema?.auditDate?.value).format(REQUEST_DATE_FORMAT)
    setValue(formSchema.auditDate.name, defAuditDate)

    if (_schema?.auditBudget?.values.length == 0) {
      let newArr = []
      newArr.push({
        id: `${uuidv4().toUpperCase()}-INSERT`,
        auditPeriod: 0,
        auditorCompany: '',
        auditorName: '',
        auditorLicenseNumber: '',
      })
      setAuditBudgetValues(newArr)
    } else {
      setAuditBudgetValues(_schema?.auditBudget?.values || [])
    }
  }, [_schema?.auditBudget?.values])

  const onDownloadInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'download')

      error ? setIsError('ดาวน์โหลด') : setIsError()
    } else {
      setIsError('ดาวน์โหลด')
    }
  }

  const onPreviewInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    console.log('fileObj => ', fileObj)
    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'preview')

      error ? setIsError('แสดง') : setIsError()
    } else {
      setIsError('แสดง')
    }
  }

  const handleSubmitDraftOne = () => {
    // console.log('onSubmitDraftOne ', id)

    // var data = {}
    // //clear error all input
    // for (const key in getValues()) {
    //   Object.assign(data, { [`${key}`]: getValues(key) })
    //   clearErrors(key)
    // }
    // console.log('data => ', data)

    // const request = {
    //   [`${_schema.issueForm.risk.name}`]: getValues(id + _schema.issueForm.risk.name) || 0,
    //   [`${_schema.issueForm?.issuesDetected?.name}`]:
    //     getValues(id + _schema.issueForm?.issuesDetected?.name) || '',
    //   [`${_schema.issueForm?.explanation?.name}`]:
    //     getValues(id + _schema.issueForm?.explanation?.name) || '',
    //   [`${_schema.issueForm?.explanationResult?.name}`]:
    //     getValues(id + _schema.issueForm?.explanationResult?.name) || 0,
    // }

    onSubmitDraftOne()
  }

  const generateRiskBlockNew = (
    riskSchema,
    risk,
    questionid,
    issueListIndex,
    issuesIndex,
    riskIndex
  ) => {
    var id = questionid + '_' + risk.id + '_'
    return (
      <Panel key={id} bordered style={{ marginTop: 10 }}>
        <Row style={{ marginTop: 10 }}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[id + riskSchema.risk.name]} />
            <Controller
              name={id + riskSchema.risk.name}
              control={control}
              defaultValue={risk.risk}
              rules={isValidators(riskSchema.risk.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={riskSchema.risk.options}
                    disabled={disabled}
                    value={props.value}
                    block
                    searchable={false}
                    placeholder={'เลือก' + riskSchema.risk.label}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={1} md={1} sm={24} xs={24}>
            <ControlLabel>{requiredFiled(riskSchema.risk.validators)}</ControlLabel>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Row>
            <Col lg={12} md={12} sm={24} xs={24} style={headerStyle}>
              {/* <p style={{ padding: 5, marginTop: 5 }}>{riskSchema?.issuesDetected?.label}</p> */}
              <ControlLabel>
                {requiredFiled(
                  riskSchema?.issuesDetected?.validators,
                  riskSchema?.issuesDetected?.label
                )}
              </ControlLabel>
            </Col>

            <Col lg={12} md={12} sm={24} xs={24} style={headerStyle}>
              {/* <p style={{ padding: 5, marginTop: 5 }}>{riskSchema?.explanation?.label}</p> */}
              <ControlLabel>
                {requiredFiled(riskSchema?.explanation?.validators, riskSchema?.explanation?.label)}
              </ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              {/* inptBlock1 */}
              {!disabled ? (
                <div style={{ padding: '0px 5px 0px 5px', marginTop: 45 }}>
                  <CKEditorBlankFrom
                    schema={riskSchema?.issuesDetected}
                    value={risk?.issuesDetected}
                    name={id + riskSchema?.issuesDetected?.name}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideToolbar={true}
                    noControlLabel={true}
                  />
                </div>
              ) : (
                <>
                  <div
                    style={{ wordWrap: 'break-word', marginTop: 50 }}
                    dangerouslySetInnerHTML={{
                      __html: risk?.issuesDetected,
                    }}
                  />
                </>
              )}
            </Col>

            <Col lg={12} md={12} sm={24} xs={24}>
              {/* inptBlock1 */}
              <div style={{ marginTop: 3 }}>
                <ErrorMessage error={errors[id + riskSchema.explanationResult.name]} />
                <Controller
                  name={id + riskSchema?.explanationResult?.name}
                  control={control}
                  // defaultValue={riskSchema?.explanationResult?.value}
                  defaultValue={risk.explanationResult}
                  rules={isValidators(riskSchema?.explanationResult?.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={riskSchema?.explanationResult?.options}
                        value={props.value}
                        disabled={disabled}
                        block
                        searchable={false}
                        placeholder={'เลือก' + riskSchema?.explanationResult?.label}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </div>

              {!disabled ? (
                <div style={{ padding: '0px 5px 0px 5px', marginTop: -5 }}>
                  <CKEditorBlankFrom
                    schema={riskSchema?.explanation}
                    value={risk?.explanation}
                    name={id + riskSchema?.explanation?.name}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideToolbar={true}
                    noControlLabel={true}
                  />
                </div>
              ) : (
                <>
                  <div
                    style={{ wordWrap: 'break-word', marginTop: 10 }}
                    dangerouslySetInnerHTML={{
                      __html: risk?.explanation,
                    }}
                  />
                </>
              )}
            </Col>
          </Row>
        </Row>

        {!disabled && (
          <div style={{ textAlign: 'right', marginTop: 10 }}>
            <SaveButton
              style={{ marginRight: 10 }}
              onClick={() => {
                // handleSubmitDraftOne(id)
                handleSubmitDraftOne()
              }}
            >
              {'บันทึกร่าง'}
            </SaveButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              onClick={() => {
                onDeleteRisk(issueListIndex, issuesIndex, riskIndex, id)
              }}
              icon={
                <Icon appearance="ghost" icon={'trash'} className="bt-gost-icon-radius-cancel" />
              }
            >
              ลบ
            </IconButton>
          </div>
        )}
      </Panel>
    )
  }

  const panelInput = (item, issueListIndex, issuesIndex) => {
    return (
      <>
        {item.risks?.map((risk, index) => {
          return (
            !risk?.isDeleted &&
            risk.id &&
            generateRiskBlockNew(
              _schema.issueForm,
              risk,
              item.issueCode,
              issueListIndex,
              issuesIndex,
              index
            )
          )
        })}

        {!disabled && (
          <div className="right">
            <IconButton
              appearance="ghost"
              style={{
                margin: 10,
              }}
              onClick={() => handleAddRisk(_schema.issueForm, issueListIndex, issuesIndex)}
              icon={<Icon appearance="ghost" icon={'plus'} className="bt-gost-icon-radius" />}
              //disabled={disabled}
            >
              เพิ่มประเด็นตรวจพบ
            </IconButton>
          </div>
        )}
      </>
    )
  }

  const handleAddRisk = (riskForm, issueListIndex, issuesIndex, riskIndex) => {
    //let newRiskForm = cloneDeep(riskForm)
    let newRiskForm = {
      id: `${uuidv4().toUpperCase()}-ADDNEW`,
      risk: null,
      riskName: '',
      issuesDetected: '',
      explanation: '',
      // trackingResults: null,
      // trackingResultsDetail: '',
    }

    setFormSchema((state) => ({
      ...state,
      issueList: state.issueList.map((e, eIndex) => {
        if (eIndex == issueListIndex) {
          return {
            ...e,
            issues: e.issues.map((q, qIndex) => {
              if (qIndex == issuesIndex) {
                return { ...q, risks: [...q.risks, newRiskForm] }
              } else {
                return { ...q }
              }
            }),
          }
        } else {
          return { ...e }
        }
      }),
    }))
  }

  const handleAddAuditBudget = () => {
    // console.log('handleAddAuditBudget', auditBudgetValues)

    let newArr = cloneDeep(auditBudgetValues)

    const newAuditBudget = {
      id: `${uuidv4().toUpperCase()}-INSERT`,
      auditPeriod: 0,
      auditorCompany: '',
      auditorName: '',
      auditorLicenseNumber: '',
    }

    newArr.push(newAuditBudget)
    setAuditBudgetValues(newArr)
  }

  const generateAuditBudgetNew = (valuesIndex, valuesItem) => {
    return (
      <>
        {auditPeriodValues == '1' || formSchema.auditPeriod.value == '1' ? (
          <Row style={{ marginBottom: 10 }} key={valuesIndex}>
            <Col lg={1} md={1} sm={24} xs={24}>
              {`${valuesIndex + 1}.)`}
            </Col>
            <Col lg={3} md={3} sm={24} xs={24}>
              <ControlLabel>{formSchema.auditBudget.auditPeriod.label}</ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditPeriod.name]}
              />

              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditPeriod.name}
                control={control}
                defaultValue={valuesItem.auditPeriod || '0'}
                // rules={isValidators(formSchema.auditBudget.auditPeriod.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditPeriod.label}
                      value={props.value}
                      type="number"
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditPeriod', value)
                      }}
                      disabled={formSchema.auditBudget.auditPeriod.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>{formSchema.auditBudget.auditorCompany.label}</ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditorCompany.name]}
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorCompany.name}
                control={control}
                defaultValue={valuesItem.auditorCompany || ''}
                // rules={isValidators(formSchema.auditBudget.auditorCompany.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorCompany.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorCompany', value)
                      }}
                      disabled={formSchema.auditBudget.auditorCompany.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>{formSchema.auditBudget.auditorName.label}</ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditorName.name]}
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorName.name}
                control={control}
                defaultValue={valuesItem.auditorName || ''}
                // rules={isValidators(formSchema.auditBudget.auditorName.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorName.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorName', value)
                      }}
                      disabled={formSchema.auditBudget.auditorName.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>{formSchema.auditBudget.auditorLicenseNumber.label}</ControlLabel>
              <ErrorMessage
                error={
                  errors[valuesItem.id + '_' + formSchema.auditBudget.auditorLicenseNumber.name]
                }
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorLicenseNumber.name}
                control={control}
                defaultValue={valuesItem.auditorLicenseNumber || ''}
                // rules={isValidators(formSchema.auditBudget.auditorLicenseNumber.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorLicenseNumber.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorLicenseNumber', value)
                      }}
                      disabled={formSchema.auditBudget.auditorLicenseNumber.disabled}
                    />
                  )
                }}
              />
            </Col>
            {!disabled && (
              <Col lg={2} md={2} sm={24} xs={24}>
                <div style={{ marginTop: 24 }}>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    onClick={() => {
                      onDeleteAuditBudget(valuesIndex)
                    }}
                    disabled={valuesIndex == 0}
                    icon={
                      <Icon
                        appearance="ghost"
                        icon={'trash'}
                        className="bt-gost-icon-radius-cancel"
                      />
                    }
                  >
                    ลบ
                  </IconButton>
                </div>
              </Col>
            )}
          </Row>
        ) : (
          <Row style={{ marginBottom: 10 }} key={valuesIndex}>
            <Col lg={1} md={1} sm={24} xs={24}>
              {`${valuesIndex + 1}.)`}
            </Col>
            <Col lg={3} md={3} sm={24} xs={24}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudget.auditPeriod.validators,
                  formSchema.auditBudget.auditPeriod.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditPeriod.name]}
              />

              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditPeriod.name}
                control={control}
                defaultValue={valuesItem.auditPeriod || '0'}
                rules={isValidators(formSchema.auditBudget.auditPeriod.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditPeriod.label}
                      value={props.value}
                      type="number"
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditPeriod', value)
                      }}
                      disabled={formSchema.auditBudget.auditPeriod.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudget.auditorCompany.validators,
                  formSchema.auditBudget.auditorCompany.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditorCompany.name]}
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorCompany.name}
                control={control}
                defaultValue={valuesItem.auditorCompany || ''}
                rules={isValidators(formSchema.auditBudget.auditorCompany.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorCompany.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorCompany', value)
                      }}
                      disabled={formSchema.auditBudget.auditorCompany.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudget.auditorName.validators,
                  formSchema.auditBudget.auditorName.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={errors[valuesItem.id + '_' + formSchema.auditBudget.auditorName.name]}
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorName.name}
                control={control}
                defaultValue={valuesItem.auditorName || ''}
                rules={isValidators(formSchema.auditBudget.auditorName.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorName.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorName', value)
                      }}
                      disabled={formSchema.auditBudget.auditorName.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={24} xs={24}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudget.auditorLicenseNumber.validators,
                  formSchema.auditBudget.auditorLicenseNumber.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={
                  errors[valuesItem.id + '_' + formSchema.auditBudget.auditorLicenseNumber.name]
                }
              />
              <Controller
                name={valuesItem.id + '_' + formSchema.auditBudget.auditorLicenseNumber.name}
                control={control}
                defaultValue={valuesItem.auditorLicenseNumber || ''}
                rules={isValidators(formSchema.auditBudget.auditorLicenseNumber.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudget.auditorLicenseNumber.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                        handleSetValueAuditBudget(valuesIndex, 'auditorLicenseNumber', value)
                      }}
                      disabled={formSchema.auditBudget.auditorLicenseNumber.disabled}
                    />
                  )
                }}
              />
            </Col>
            {!disabled && (
              <Col lg={2} md={2} sm={24} xs={24}>
                <div style={{ marginTop: 24 }}>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    onClick={() => {
                      onDeleteAuditBudget(valuesIndex)
                    }}
                    disabled={valuesIndex == 0}
                    icon={
                      <Icon
                        appearance="ghost"
                        icon={'trash'}
                        className="bt-gost-icon-radius-cancel"
                      />
                    }
                  >
                    ลบ
                  </IconButton>
                </div>
              </Col>
            )}
          </Row>
        )}
      </>
    )
  }

  const onDeleteAuditBudget = (valuesIndex) => {
    let newArr = cloneDeep(auditBudgetValues)

    newArr.splice(valuesIndex, 1)

    setAuditBudgetValues(newArr)
  }

  const onDeleteRisk = (issueListIndex, issuesIndex, riskIndex, id) => {
    const risk = getValues(id + _schema.issueForm.risk.name) || null
    const issuesDetected = getValues(id + _schema.issueForm?.issuesDetected?.name) || null
    const explanation = getValues(id + _schema.issueForm?.explanation?.name) || null

    // console.log('risk => ', risk)
    // console.log('issuesDetected => ', issuesDetected)
    // console.log('explanation => ', explanation)

    if (risk && issuesDetected && explanation) {
      setRequest({
        issueListIndex,
        issuesIndex,
        riskIndex,
      })
      setIsShowConfirmDelete(true)
    } else {
      handleDeleteRisk(issueListIndex, issuesIndex, riskIndex)
    }
  }

  const handleDeleteRisk = (_issueListIndex, _issuesIndex, _riskIndex) => {
    // console.log('request', request)

    // issueListIndex, issuesIndex, riskIndex
    const issueListIndex = request ? request?.issueListIndex : _issueListIndex
    const issuesIndex = request ? request?.issuesIndex : _issuesIndex
    const riskIndex = request ? request?.riskIndex : _riskIndex

    setFormSchema((state) => ({
      ...state,
      issueList: state.issueList.map((e, eIndex) => {
        if (eIndex == issueListIndex) {
          return {
            ...e,
            issues: e.issues.map((q, qIndex) => {
              if (qIndex == issuesIndex) {
                return {
                  ...q,
                  risks: q.risks.map((r, rIndex) => {
                    if (rIndex == riskIndex) {
                      return { ...r, isDeleted: true }
                    } else {
                      return { ...r }
                    }
                  }),
                }
              } else {
                return { ...q }
              }
            }),
          }
        } else {
          return { ...e }
        }
      }),
    }))

    setIsShowConfirmDelete(false)
    setRequest()
  }

  const handleSetValueAuditBudget = (index, key, value) => {
    console.log('handleSetValueAuditBudget => ', index, key, value)

    let newArr = cloneDeep(auditBudgetValues)

    newArr[index].auditPeriod = key == 'auditPeriod' ? value : newArr[index]?.auditPeriod
    newArr[index].auditorCompany = key == 'auditorCompany' ? value : newArr[index]?.auditorCompany
    newArr[index].auditorName = key == 'auditorName' ? value : newArr[index]?.auditorName
    newArr[index].auditorLicenseNumber =
      key == 'auditorLicenseNumber' ? value : newArr[index]?.auditorLicenseNumber

    setAuditBudgetValues(newArr)
  }

  const onDeleteAuditBudgetAll = () => {
    const newAuditBudget = {
      id: `${uuidv4().toUpperCase()}-INSERT`,
      auditPeriod: 0,
      auditorCompany: '',
      auditorName: '',
      auditorLicenseNumber: '',
    }

    let newArr = []
    newArr.push(newAuditBudget)
    setAuditBudgetValues(newArr)
  }

  const messageTo = (msg) => {
    const msgSplit = msg?.split('|')

    let _type = 'info',
      _desc = '',
      _showIcon = false

    if (msgSplit?.length == 3) {
      _showIcon = msgSplit[0] == '1' ? true : false
      _type = msgSplit[1]
      _desc = msgSplit[2]
    }

    return (
      <>
        <Row style={{ marginTop: -20, marginBottom: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Message
              showIcon={_showIcon}
              type={_type}
              description={<div dangerouslySetInnerHTML={{ __html: _desc }} />}
            />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <Panel
        header={'ผลการตรวจสอบภายใน'}
        bordered
        collapsible
        defaultExpanded
        style={{ marginTop: 20 }}
      >
        <Panel bordered header={'รายงานตรวจสอบฉบับสมบูรณ์'}>
          <>
            {isError && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`เกิดข้อผิดพลาดในการ${isError} กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                />
              </Row>
            )}

            <Row>
              <Col lg={8} md={8} sm={24} xs={24}>
                <b>กำกับ/ประเมินผล/ตรวจสอบ</b>
              </Col>
              <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ButtonGroup>
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        คลิกเพื่อ <i>แสดงไฟล์</i>
                      </Tooltip>
                    }
                  >
                    <IconButton
                      appearance="ghost"
                      size="sm"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      disabled={
                        !formSchema?.auditBook?.value.find(
                          (e) => e.name.indexOf('06') != -1 && e.path != ''
                        )
                      }
                      onClick={(e) => onPreviewInfoma()}
                    />
                  </Whisper>

                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        คลิกเพื่อ <i>ดาวน์โหลดไฟล์</i>
                      </Tooltip>
                    }
                  >
                    <IconButton
                      appearance="ghost"
                      size="sm"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      disabled={
                        !formSchema?.auditBook?.value.find(
                          (e) => e.name.indexOf('06') != -1 && e.path != ''
                        )
                      }
                      onClick={(e) => onDownloadInfoma()}
                    />
                  </Whisper>
                </ButtonGroup>
              </Col>
            </Row>
          </>
        </Panel>

        <Panel>
          {formSchema.comments?.map((item, index) => {
            return (
              <>
                <Message
                  type="warning"
                  description={
                    <>
                      <p>{item?.actor} : </p>
                      <p style={{ marginLeft: 20 }}>{item?.comment && `${item?.comment || ''}`}</p>
                    </>
                  }
                />
              </>
            )
          })}

          <Row style={{ marginTop: 30 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditByCompany.validators,
                  formSchema.auditByCompany.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditByCompany.name]} />
              <Controller
                name={formSchema.auditByCompany.name}
                control={control}
                defaultValue={formSchema.auditByCompany.value || ''}
                rules={isValidators(formSchema.auditByCompany.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditByCompany.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.auditByCompany.disabled}
                    />
                  )
                }}
              />
            </Col>

            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.auditName.validators, formSchema.auditName.label)}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditName.name]} />
              <Controller
                name={formSchema.auditName.name}
                control={control}
                defaultValue={formSchema.auditName.value || ''}
                rules={isValidators(formSchema.auditName.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditName.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.auditName.disabled}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.auditPeriod.validators, formSchema.auditPeriod.label)}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditPeriod.name]} />
              <Controller
                name={formSchema.auditPeriod.name}
                control={control}
                defaultValue={formSchema.auditPeriod.value || ''}
                rules={isValidators(formSchema.auditPeriod.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditPeriod.label}
                      value={props.value}
                      maxLength={getMaxLengthData(formSchema.auditPeriod.validators).value}
                      onChange={(value, e) => {
                        if (isNaN(value)) {
                          return
                        }
                        props.onChange(value.trim())
                        setAuditPeriodValues(value.trim())
                      }}
                      disabled={formSchema.auditPeriod.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.auditDate.validators, formSchema.auditDate.label)}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {/* {console.log(
                'date => ',
                moment(formSchema?.auditDate?.value).format(REQUEST_DATE_FORMAT)
              )} */}
              <ErrorMessage error={errors[formSchema.auditDate.name]} />
              <DatePickerCustom
                {...props}
                placement="auto"
                value={auditDate}
                disabled={formSchema.auditDate.disabled}
                onChange={(value) => {
                  console.log('vvvvv => ', value)
                  setAuditDate(value)
                  // console.log('auditDate ', moment(value).format(DD_MM_YYYY_SLASH))
                  if (value) {
                    setValue(
                      formSchema.auditDate.name,
                      moment(value).format(REQUEST_DATE_FORMAT) || null
                    )
                  } else {
                    setValue(formSchema.auditDate.name, null)
                  }
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditorLicenseNumber.validators,
                  formSchema.auditorLicenseNumber.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditorLicenseNumber.name]} />
              <Controller
                name={formSchema.auditorLicenseNumber.name}
                control={control}
                defaultValue={formSchema.auditorLicenseNumber.value || ''}
                rules={isValidators(formSchema.auditorLicenseNumber.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditorLicenseNumber.label}
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.auditorLicenseNumber.disabled}
                    />
                  )
                }}
              />
            </Col>
            {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.auditResults.validators, formSchema.auditResults.label)}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditResults.name]} />
              <Controller
                name={formSchema.auditResults.name}
                control={control}
                defaultValue={formSchema.auditResults.value}
                rules={isValidators(formSchema.auditResults.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.auditResults.options}
                      disabled={formSchema.auditResults.disabled}
                      value={props.value}
                      block
                      searchable={false}
                      placeholder={'เลือก' + formSchema.auditResults.label}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col> */}
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudgetYear.validators,
                  formSchema.auditBudgetYear.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditBudgetYear.name]} />
              <Controller
                name={formSchema.auditBudgetYear.name}
                control={control}
                defaultValue={formSchema.auditBudgetYear.value || ''}
                rules={isValidators(formSchema.auditBudgetYear.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudgetYear.label}
                      // type="number"
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.auditBudgetYear.disabled}
                    />
                  )
                }}
              />
            </Col>
          </Row>
          {/* <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.auditBudgetYear.validators,
                  formSchema.auditBudgetYear.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.auditBudgetYear.name]} />
              <Controller
                name={formSchema.auditBudgetYear.name}
                control={control}
                defaultValue={formSchema.auditBudgetYear.value || ''}
                rules={isValidators(formSchema.auditBudgetYear.validators)}
                render={(props) => {
                  return (
                    <Input
                      placeholder={'ระบุ' + formSchema.auditBudgetYear.label}
                      // type="number"
                      value={props.value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.auditBudgetYear.disabled}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          </Row> */}
          <Row style={{ marginTop: 20 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              ตรวจสอบการใช้จ่ายเงินโดยบริษัท
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <Panel bordered>
                {auditBudgetValues.map((item, index) => {
                  return generateAuditBudgetNew(index, item)
                })}

                {!disabled && (
                  <div style={{ marginTop: 5 }}>
                    <ButtonToolbar style={{ textAlign: 'right' }}>
                      <IconButton
                        appearance="ghost"
                        onClick={() => handleAddAuditBudget()}
                        icon={
                          <Icon appearance="ghost" icon={'plus'} className="bt-gost-icon-radius" />
                        }
                      >
                        เพิ่มตรวจสอบใช้จ่ายเงิน
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        onClick={() => {
                          onDeleteAuditBudgetAll()
                        }}
                        icon={
                          <Icon
                            appearance="ghost"
                            icon={'trash'}
                            className="bt-gost-icon-radius-cancel"
                          />
                        }
                      >
                        ลบตรวจสอบใช้จ่ายเงินทั้งหมด
                      </IconButton>
                    </ButtonToolbar>
                  </div>
                )}
              </Panel>
            </Col>
          </Row>
          <Row style={{ marginTop: 30 }}>
            <Col lg={18} md={18} sm={24} xs={24}>
              <InputForm
                schema={formSchema.description}
                label={formSchema.conclusion}
                placeholder={formSchema.conclusion}
                rows={3}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                // style={{ marginTop: -15 }}
              />
            </Col>
            {auditRole?.isInternalAuditor && (
              <Col lg={6} md={6} sm={24} xs={24}>
                <InputSelectForm
                  schema={formSchema.projectGrade}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  disabled={disabled}
                />
              </Col>
            )}
          </Row>
        </Panel>

        <Row style={{ marginTop: -20, marginBottom: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Message
              // showIcon
              type="info"
              description={
                <div dangerouslySetInnerHTML={{ __html: formSchema.riskDetail.label }} />
              }
              style={{ marginBottom: 10, marginTop: 20 }}
            />
          </Col>
          {formSchema.riskInfo && (
            <>
              <Col lg={24} md={24} sm={24} xs={24}>
                <Message
                  // showIcon
                  type="info"
                  description={
                    <div>
                      <p>{formSchema.riskInfo.header}</p>
                      <br />
                      <List bordered style={{ backgroundColor: 'transparent' }}>
                        <List.Item style={{ backgroundColor: 'transparent' }}>
                          <FlexboxGrid align="middle" className="banner">
                            <FlexboxGrid.Item
                              componentClass={Col}
                              colspan={24}
                              lg={4}
                              md={4}
                              sm={6}
                              xs={24}
                              align="center"
                            >
                              <strong>ระดับความเสี่ยง</strong>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item
                              componentClass={Col}
                              colspan={24}
                              lg={20}
                              md={20}
                              sm={18}
                              xs={24}
                              align="center"
                            >
                              <strong>คำอธิบาย</strong>
                            </FlexboxGrid.Item>
                          </FlexboxGrid>
                        </List.Item>
                        {formSchema.riskInfo.details?.map((e) => {
                          return (
                            <List.Item style={{ backgroundColor: 'transparent' }}>
                              <FlexboxGrid className="banner">
                                <FlexboxGrid.Item
                                  componentClass={Col}
                                  colspan={24}
                                  lg={4}
                                  md={4}
                                  sm={6}
                                  xs={24}
                                  align="center"
                                >
                                  <strong>{e.level}</strong>
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item
                                  componentClass={Col}
                                  colspan={24}
                                  lg={20}
                                  md={20}
                                  sm={18}
                                  xs={24}
                                >
                                  <div dangerouslySetInnerHTML={{ __html: e.detail }} />
                                </FlexboxGrid.Item>
                              </FlexboxGrid>
                            </List.Item>
                          )
                        })}
                      </List>
                    </div>
                  }
                  style={{ marginBottom: 10, marginTop: 20 }}
                />
              </Col>
            </>
          )}
        </Row>

        {formSchema.messageTo && messageTo(formSchema.messageTo)}

        {formSchema?.issueList?.map((element, i) => {
          return (
            <Panel header={element.title} collapsible defaultExpanded key={i}>
              {element.issues?.map((item, index) => {
                return (
                  <Panel
                    key={index}
                    header={
                      <div style={{ color: 'black' }}>{item.issueCode + ' ' + item.issueName}</div>
                    }
                    collapsible
                    defaultExpanded={item?.risks?.length >= 1 && item.risks[0].id}
                    style={{ marginTop: -20 }}
                  >
                    {panelInput(item, i, index)}
                  </Panel>
                )
              })}
            </Panel>
          )
        })}

        {formSchema.otherDesc && (
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              <InputForm
                schema={formSchema.otherDesc}
                rows={4}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: 10 }}>
            <>
              <ErrorMessage error={errors[formSchema.auditorOption.name]} />
              <Controller
                name={formSchema.auditorOption.name}
                control={control}
                defaultValue={formSchema.auditorOption.value || null}
                rules={isValidators(formSchema.auditorOption.validators)}
                render={(props) => {
                  return (
                    <RadioGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        setCheckRadio(value)
                      }}
                    >
                      {formSchema.auditorOption.options.map((item, index) => {
                        let color = '',
                          _className = ''
                        switch (item.value) {
                          case 1:
                            color = '#70b144'
                            _className = 'mod1rs-icon-size-lg'
                            break
                          case 2:
                            color = '#ffbd09'
                            _className = 'mod2rs-icon-size-lg'
                            break
                          case 3:
                            color = '#fb0403'
                            _className = 'mod3rs-icon-size-lg'
                            break
                          default:
                            break
                        }
                        return (
                          <>
                            <div className={_className}>
                              <Radio
                                key={item.value}
                                value={item.value}
                                disabled={disabled}
                                style={{ marginTop: -8.5 }}
                              >
                                <div style={{ display: 'flex', marginTop: -3 }}>
                                  <Icon icon="circle" size="lg" style={{ color: color }} />
                                  <p
                                    dangerouslySetInnerHTML={{ __html: item.label }}
                                    style={{ marginLeft: 10, marginTop: 2 }}
                                  />
                                </div>
                              </Radio>
                            </div>
                          </>
                        )
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </>
          </Col>
        </Row>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันลบ'}
        show={isShowConfirmDelete}
        onCancle={() => {
          setIsShowConfirmDelete(false)
          setRequest()
        }}
        onConfirm={handleDeleteRisk}
      />
    </>
  )
}
